import type { SVGProps } from 'react';
const SvgShelter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="m18.944 6.395-4.37 12.89-.053.159-3.095-6.953a.63.63 0 0 0-.568-.369.63.63 0 0 0-.567.369l-4.37 9.817-4.37 9.82A.63.63 0 0 0 2.12 33H36.88c.572 0 .724-.431.543-.921l-3.996-7.247-3.997-7.242a.621.621 0 0 0-1.086 0l-2.741 4.963-1.106-3.268-4.375-12.89c-.19-.494-.976-.558-1.175 0z" />
  </svg>
);
export default SvgShelter;
